/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { AnswersControllerRemoveMutationResponse, AnswersControllerRemovePathParams, AnswersControllerRemove401, AnswersControllerRemove403, AnswersControllerRemove404 } from "../../models/checklistsController/AnswersControllerRemove";

function getAnswersControllerRemoveUrl(id: AnswersControllerRemovePathParams["id"]) {
  const res = { method: 'DELETE', url: `/api/v1/checklist-answers/${id}` as const }  
  return res
}

/**
 * @description Requires Edit reviews or Edit Playbooks (matching the parent application's template kind) — the permission that controls responding to an already-run application.
 * @summary Delete a checklist answer (soft delete)
 * {@link /api/v1/checklist-answers/:id}
 */
export async function answersControllerRemove(id: AnswersControllerRemovePathParams["id"], config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<AnswersControllerRemoveMutationResponse, ResponseErrorConfig<AnswersControllerRemove401 | AnswersControllerRemove403 | AnswersControllerRemove404>, unknown>({ method : "DELETE", url : getAnswersControllerRemoveUrl(id).url.toString(), ... requestConfig })  
  return res.data
}